import { SelectHTMLAttributes, forwardRef } from "react";
import { Select } from "./Select";

/** ISO-4217 valuta-lijst die AIBoek ondersteunt. EUR staat bovenaan (default/
 *  rapportagevaluta), daarna de meest voorkomende buitenlandse valuta's. */
export const SUPPORTED_CURRENCIES: { value: string; label: string }[] = [
  { value: "EUR", label: "EUR — Euro" },
  { value: "USD", label: "USD — Amerikaanse dollar" },
  { value: "GBP", label: "GBP — Britse pond" },
  { value: "CHF", label: "CHF — Zwitserse frank" },
  { value: "JPY", label: "JPY — Japanse yen" },
  { value: "CAD", label: "CAD — Canadese dollar" },
  { value: "AUD", label: "AUD — Australische dollar" },
  { value: "SEK", label: "SEK — Zweedse kroon" },
  { value: "NOK", label: "NOK — Noorse kroon" },
  { value: "DKK", label: "DKK — Deense kroon" },
  { value: "CNY", label: "CNY — Chinese yuan" },
  { value: "PLN", label: "PLN — Poolse zloty" },
  { value: "CZK", label: "CZK — Tsjechische kroon" },
  { value: "TRY", label: "TRY — Turkse lira" },
  { value: "INR", label: "INR — Indiase roepie" },
  { value: "BRL", label: "BRL — Braziliaanse real" },
  { value: "ZAR", label: "ZAR — Zuid-Afrikaanse rand" },
  { value: "AED", label: "AED — UAE dirham" },
];

interface CurrencySelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, "options"> {
  label?: string;
  error?: string;
}

/** Valuta-dropdown met de ondersteunde ISO-4217 codes. Wrapper rond de
 *  generieke <Select>; geeft de vaste currency-lijst mee als options. */
export const CurrencySelect = forwardRef<HTMLSelectElement, CurrencySelectProps>(
  ({ label, error, ...props }, ref) => {
    return (
      <Select
        ref={ref}
        label={label}
        error={error}
        options={SUPPORTED_CURRENCIES}
        {...props}
      />
    );
  }
);
CurrencySelect.displayName = "CurrencySelect";